import styled, { createGlobalStyle } from 'styled-components';

export const GSFormContact = createGlobalStyle`
  .contact-input {
    width: 100%;
  }

  #formContact .MuiGrid-item {
    padding-top: 10px !important;
    padding-bottom: 10px !important;
  }

  #formContact .MuiFormControl-root,
  #formContact .MuiTextField-root {
    width: 100%;
  }

  #formContact .MuiInputLabel-root {
    position: static !important;
    transform: none !important;
    margin-bottom: 8px;
    font-size: 16px !important;
    font-weight: 700 !important;
    line-height: 1.3;
    color: #4a4a4a !important;
  }

  #formContact .MuiInputLabel-shrink {
    transform: none !important;
  }

  #formContact .MuiOutlinedInput-notchedOutline legend {
    max-width: 0 !important;
  }

  #formContact .MuiInputBase-root {
    min-height: 52px;
    border-radius: 10px !important;
    background: #ffffff;
  }

  #formContact .MuiOutlinedInput-notchedOutline {
    border-color: #c9c9c9 !important;
    border-width: 2px !important;
  }

  #formContact .MuiInputBase-root:hover .MuiOutlinedInput-notchedOutline,
  #formContact .MuiInputBase-root.Mui-focused .MuiOutlinedInput-notchedOutline {
    border-color: #bdbdbd !important;
  }

  #formContact .MuiInputBase-input {
    padding: 14px 16px !important;
    font-size: 16px !important;
    color: #595959 !important;
  }

  #formContact .MuiInputBase-input::placeholder {
    color: #ababab !important;
    opacity: 1 !important;
  }

  #formContact .MuiSelect-select,
  #formContact .MuiNativeSelect-select {
    color: #ababab !important;
  }

  #formContact textarea.MuiInputBase-input {
    min-height: 24px !important;
    padding-top: 14px !important;
  }

  #formContact .MuiSvgIcon-root {
    color: #b7b7b7;
  }

  #formContact .MuiFormHelperText-root {
    margin-left: 4px;
    margin-top: 6px;
  }

  #formContact .MuiFormGroup-root {
    margin-top: 4px;
  }

  #formContact .MuiFormControlLabel-root {
    align-items: flex-start;
    margin: 0;
  }

  #formContact .MuiFormControlLabel-label {
    font-size: 14px !important;
    line-height: 1.35;
    color: #666 !important;
    margin-top: 2px;
  }

  #formContact .MuiCheckbox-root {
    padding: 0 8px 0 0 !important;
  }

  #formContact .MuiCheckbox-root .MuiSvgIcon-root {
    font-size: 30px;
    color: #d4d4d4;
  }

  #formContact .MuiCheckbox-root.Mui-checked .MuiSvgIcon-root {
    color: #1d73d6 !important;
  }

  #formContact .react-tel-input {
    width: 100%;
  }

  #formContact .react-tel-input .special-label {
    position: static !important;
    transform: none !important;
    margin-bottom: 8px !important;
    font-size: 16px !important;
    font-weight: 700 !important;
    line-height: 1.3;
    color: #4a4a4a !important;
  }

  #formContact .react-tel-input .form-control {
    width: 100% !important;
    height: 52px !important;
    border-radius: 10px !important;
    border: 2px solid #c9c9c9 !important;
    background: #ffffff !important;
    box-shadow: none !important;
    padding-left: 16px !important;
    font-size: 16px !important;
    color: #595959 !important;
  }

  #formContact .react-tel-input .form-control::placeholder {
    color: #ababab !important;
    opacity: 1 !important;
  }

  #formContact .react-tel-input .flag-dropdown {
    display: none !important;
  }

  @media (max-width: 767px) {
    #formContact .MuiGrid-item {
      padding-top: 8px !important;
      padding-bottom: 8px !important;
    }

    #formContact .MuiInputLabel-root,
    #formContact .react-tel-input .special-label {
      font-size: 15px !important;
      margin-bottom: 6px !important;
    }

    #formContact .MuiInputBase-root {
      min-height: 48px;
    }

    #formContact .MuiInputBase-input {
      padding: 12px 12px !important;
      font-size: 15px !important;
    }

    #formContact textarea.MuiInputBase-input {
      min-height: 20px !important;
    }

    #formContact .react-tel-input .form-control {
      height: 48px !important;
      font-size: 15px !important;
    }
  }
`
export const ContFirstFormContact = styled.div`
  position: relative;
  width: 100%;
  height: auto;
  margin: 0 auto;
  background-color: #FFFFFF;
  box-shadow: 0px 20px 43px rgba(0, 0, 0, 0.1), 0px 0px 0px rgba(0, 0, 0, 0.1);
  border-radius: 20px;
  
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  @media(min-width: 300px) and (max-width: 767px){
    width: 96%;
    margin: 40px auto;
    padding: 20px 0;
  }
  @media(min-width: 768px) and (max-width: 1023px){
    width: 80%;
    margin: 60px auto;
    padding: 40px 0;
  }
  @media(min-width: 1024px) and (max-width: 1079px){
    width: 80%;
    margin: 30px auto;
    padding: 20px 0;
  }
  @media(min-width: 1080px) and (max-width: 1279px){
    width: 80%;
    margin: 30px auto;
    padding: 20px 0;
  }
  @media(min-width: 1280px) and (max-width: 1407px){
    width: 90%;
    margin: 0px auto;
    padding: 20px 0;
  }
  @media(min-width: 1408px) and (max-width: 1439px){
    width: 80%;
    margin: 23px auto;
    padding: 40px 0;
  }
  @media(min-width: 1440px) and (max-width: 1919px){
    width: 70%;
    margin: 30px auto;
    padding: 40px 0;
  }
  @media(min-width: 1920px){
    width: 60%;
    margin: 30px auto;
    padding: 40px 0;
  }
`
export const ContAlertContact = styled.div`
  position: absolute;
  width: 100%;
  z-index: 2;
  
  @media(min-width: 300px) and (max-width: 767px){
    width: 90%;
    top: -45px;
  }
  @media(min-width: 768px) and (max-width: 1023px){
    width: 90%;
    top: -20px;
  }
  @media(min-width: 1024px) and (max-width: 1079px){
    width: 80%;
    top: -22px;
  }
  @media(min-width: 1080px) and (max-width: 1279px){
    width: 75%;
    top: 0px;
  }
  @media(min-width: 1280px) and (max-width: 1407px){
    width: 75%;
    top: 0px;
  }
  @media(min-width: 1408px) and (max-width: 1439px){
    width: 75%;
    top: -35px;
  }
  @media(min-width: 1440px) and (max-width: 1919px){
    width: 75%;
    top: -25px;
  }
  @media(min-width: 1920px){
    width: 70%;
    top: -40px;
  }
`
export const ContFormContact = styled.div`
  position: relative;
  height: auto;
  
  @media(min-width: 300px) and (max-width: 767px){
    width: 90%;
  }
  @media(min-width: 768px) and (max-width: 1023px){
    width: 90%;
  }
  @media(min-width: 1024px) and (max-width: 1079px){
    width: 80%;
  }
  @media(min-width: 1080px) and (max-width: 1279px){
    width: 75%;
  }
  @media(min-width: 1280px) and (max-width: 1407px){
    width: 75%;
  }
  @media(min-width: 1408px) and (max-width: 1439px){
    width: 75%;
  }
  @media(min-width: 1440px) and (max-width: 1919px){
    width: 75%;
  }
  @media(min-width: 1920px){
    width: 70%;
  }
`
export const ContFormContactItem = styled.div`
  @media(min-width: 300px) and (max-width: 767px){
    margin: 15px 0;
  }
  @media(min-width: 768px) and (max-width: 1023px){
    margin: 15px 0;
  }
  @media(min-width: 1024px) and (max-width: 1079px){
    margin: 5px 0;
  }
  @media(min-width: 1080px) and (max-width: 1279px){
    margin: 10px 0;
  }
  @media(min-width: 1280px) and (max-width: 1407px){
    margin: 10px 0;
  }
  @media(min-width: 1408px) and (max-width: 1439px){
    margin: 10px 0;
  }
  @media(min-width: 1440px) and (max-width: 1919px){
    margin: 10px 0;
  }
  @media(min-width: 1920px){
    margin: 10px 0;
  }
`
export const ContButtonSend = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  
  @media(min-width: 300px) and (max-width: 767px){
    justify-content: center;
  }
  @media(min-width: 768px) and (max-width: 1023px){
    justify-content: center;
  }
  @media(min-width: 1024px) and (max-width: 1079px){
    justify-content: center;
  }
  @media(min-width: 1080px) and (max-width: 1279px){
    justify-content: center;
  }
  @media(min-width: 1280px) and (max-width: 1407px){
    justify-content: flex-start;
  }
  @media(min-width: 1408px) and (max-width: 1439px){
    justify-content: flex-start;
  }
  @media(min-width: 1440px) and (max-width: 1919px){
    justify-content: flex-start;
  }
  @media(min-width: 1920px){
    justify-content: flex-start;
  }
`
